import { render, staticRenderFns } from "./verification.vue?vue&type=template&id=ca7f70e6&scoped=true&"
import script from "./verification.vue?vue&type=script&lang=js&"
export * from "./verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7f70e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7f70e6')) {
      api.createRecord('ca7f70e6', component.options)
    } else {
      api.reload('ca7f70e6', component.options)
    }
    module.hot.accept("./verification.vue?vue&type=template&id=ca7f70e6&scoped=true&", function () {
      api.rerender('ca7f70e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/verifition/verification.vue"
export default component.exports